import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./features/Auth/authSlice";
import {
  dmsCatalogApi,
  dmsReducer,
} from "./features/Integration/DmsSetupSlice";
import { orderApi } from "./features/Order/orderSlice";
import { productApi, productReducer } from "./features/Product/productSlice";
import { partApi } from "./features/Part/partSlice";
import { CustomerApi } from "./features/Customer/CustomerSlice";
import { gravitySettingApi } from "./features/Gravity/GravitySettingSlice";
import { shoppingPortalSettingApi } from "./features/Setting/Shopping Portal/ShoppingPortalSettingSlice";
import {
  DashboardApi,
  dashboardReducer,
} from "./features/Dashboard/DashboardSlice";
import {
  shoppingPortalApi,
  shoppingPortalReducer,
} from "./features/ShoppingPortal/ShoppingPortalSlice";
import { dealerCustomersApi } from "./features/Dealer/Customer/CustomersSlice";
import { quotationApi } from "./features/Quotation/quotationSlice";
import { AppGridReducer, appGridSettingApi } from "./features/App/AppGridSlice";
import { widgetReducer } from "./features/Dashboard/widgetSlice";
import { dealerSettingsApi } from "./features/Dealer/DealerSettingsSlice";

const rootReducer = combineReducers({
  dmsReducer,
  productReducer,
  authReducer,
  dashboardReducer,
  shoppingPortalReducer,
  AppGridReducer,
  widgetReducer,
  [productApi.reducerPath]: productApi.reducer,
  [dmsCatalogApi.reducerPath]: dmsCatalogApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [partApi.reducerPath]: partApi.reducer,
  [CustomerApi.reducerPath]: CustomerApi.reducer,
  [gravitySettingApi.reducerPath]: gravitySettingApi.reducer,
  [shoppingPortalSettingApi.reducerPath]: shoppingPortalSettingApi.reducer,
  [shoppingPortalApi.reducerPath]: shoppingPortalApi.reducer,
  [dealerCustomersApi.reducerPath]: dealerCustomersApi.reducer,
  [DashboardApi.reducerPath]: DashboardApi.reducer,
  [quotationApi.reducerPath]: quotationApi.reducer,
  [appGridSettingApi.reducerPath]: appGridSettingApi.reducer,
  [dealerSettingsApi.reducerPath]: dealerSettingsApi.reducer,
});
export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
